const SET_SNACKBAR = 'SET_SNACKBAR'
const SET_LOADING = 'SET_LOADING'
const SET_USER = 'SET_USER'
const SET_CURRENT_COUNTRY_CODE = 'SET_CURRENT_COUNTRY_CODE'
const SET_TEMPORARY_CSRF = 'SET_TEMPORARY_CSRF'

const state = {
  snackmsg: '',
  snackstatus: '',
  loading: {
    state: false,
    msg: ''
  },
  user: {},
  countrycode: '',
  tempcsrf: ''
}

const getters = {
  snackmsg: state => state.snackmsg,
  snackstatus: state => state.snackstatus,
  loading: state => state.loading,
  user: state => state.user,
  countrycode: state => state.countrycode,
  tempcsrf: state => state.tempcsrf
}

const mutations = {
  [SET_SNACKBAR]: (state, data) => {
    state.snackmsg = data.msg
    state.snackstatus = data.status
  },
  [SET_LOADING]: (state, data) => {
    state.loading = data
  },
  [SET_USER]: (state, data) => {
    state.user = data
  },
  [SET_CURRENT_COUNTRY_CODE]: (state, data) => {
    state.countrycode = data
  },
  [SET_TEMPORARY_CSRF]: (state, data) => {
    state.tempcsrf = data
  }
}

export { state, getters, mutations }
